import employees from './employees.json';

export default {
  employees,
};
